import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { ErrorMessageMsisdn } from './error-message-msisdn.data';

@Pipe({
    name: 'errorMessage',
    standalone: true
})

export class ErrorMessagePipe implements PipeTransform {
    transform(value: ValidationErrors | null) {
        if (!value) {
            return '';
        }

        for (const error of ErrorMessageMsisdn) {
            if (value[error.name]) {
                return error.message;
            }
        }

        return '';
    }
    
}